import firebaseApp from "./firebase";

const db = firebaseApp.firestore();
db.settings({
  timestampsInSnapshots: true
});

export const teamsRef = db.collection("teams");

export const teamMatchingsRef = db.collection("team_matchings");

export const usersRef = db.collection("users");
